/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { NgModule } from '@angular/core';
import { CONTEXT_PATH, KEYCLOAK_AUTH_SERVER_URL, KEYCLOAK_JSON_URL, KEYCLOAK_MIN_VALIDITY, KEYCLOAK_REALM, KEYCLOAK_RESOURCE, KEYCLOAK_SECRET, } from '@gh/config';
import { CoreKeycloakAuthModule } from '@gh/core-auth-keycloak';
import { CoreAuthMockModule } from '@gh/core-auth-mock';
import { NoopModule } from '@gh/core-util';
import * as i0 from "@angular/core";
import * as i1 from "../../core-auth-keycloak/core-keycloak-auth.module";
import * as i2 from "../../core-auth-mock/core-auth-mock.module";
export function logoutOptionsFactory() {
    return {
        redirectUri: window.location.origin + CONTEXT_PATH,
    };
}
export var configuration = {
    configuration: KEYCLOAK_JSON_URL ? KEYCLOAK_JSON_URL : {
        url: KEYCLOAK_AUTH_SERVER_URL,
        realm: KEYCLOAK_REALM,
        clientId: KEYCLOAK_RESOURCE,
        credentials: !KEYCLOAK_SECRET ? undefined : {
            secret: KEYCLOAK_SECRET,
        },
    },
    initOptions: {
        onLoad: 'check-sso',
    },
    minValidity: KEYCLOAK_MIN_VALIDITY,
    logoutOptions: logoutOptionsFactory,
};
var SupplierAuthKeycloakModule = /** @class */ (function () {
    function SupplierAuthKeycloakModule() {
    }
    SupplierAuthKeycloakModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierAuthKeycloakModule });
    SupplierAuthKeycloakModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierAuthKeycloakModule_Factory(t) { return new (t || SupplierAuthKeycloakModule)(); }, imports: [[
                CoreKeycloakAuthModule.asStandalone(configuration),
            ]] });
    return SupplierAuthKeycloakModule;
}());
export { SupplierAuthKeycloakModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierAuthKeycloakModule, { imports: [i1.CoreKeycloakAuthModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierAuthKeycloakModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CoreKeycloakAuthModule.asStandalone(configuration),
                ],
            }]
    }], null, null); })();
var SupplierAuthKeycloakWithMockModule = /** @class */ (function () {
    function SupplierAuthKeycloakWithMockModule() {
    }
    SupplierAuthKeycloakWithMockModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierAuthKeycloakWithMockModule });
    SupplierAuthKeycloakWithMockModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierAuthKeycloakWithMockModule_Factory(t) { return new (t || SupplierAuthKeycloakWithMockModule)(); }, imports: [[
                CoreKeycloakAuthModule.asDecorated(configuration),
                CoreAuthMockModule.asDecorating(),
            ]] });
    return SupplierAuthKeycloakWithMockModule;
}());
export { SupplierAuthKeycloakWithMockModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierAuthKeycloakWithMockModule, { imports: [i1.CoreKeycloakAuthModule, i2.CoreSecondaryAuthMockModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierAuthKeycloakWithMockModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CoreKeycloakAuthModule.asDecorated(configuration),
                    CoreAuthMockModule.asDecorating(),
                ],
            }]
    }], null, null); })();
var SupplierAuthMockModule = /** @class */ (function () {
    function SupplierAuthMockModule() {
    }
    SupplierAuthMockModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierAuthMockModule });
    SupplierAuthMockModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierAuthMockModule_Factory(t) { return new (t || SupplierAuthMockModule)(); }, imports: [[
                CoreAuthMockModule.asStandalone({
                    fields: ['email'],
                    width: 400,
                }),
            ]] });
    return SupplierAuthMockModule;
}());
export { SupplierAuthMockModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierAuthMockModule, { imports: [i2.CorePrimaryAuthMockModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierAuthMockModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CoreAuthMockModule.asStandalone({
                        fields: ['email'],
                        width: 400,
                    }),
                ],
            }]
    }], null, null); })();
var SupplierAuthConfigModule = /** @class */ (function () {
    function SupplierAuthConfigModule() {
    }
    SupplierAuthConfigModule.useKeycloak = function () {
        return { ngModule: SupplierAuthKeycloakModule };
    };
    SupplierAuthConfigModule.useKeycloakWithMock = function () {
        return { ngModule: SupplierAuthKeycloakWithMockModule };
    };
    SupplierAuthConfigModule.useMock = function () {
        return { ngModule: SupplierAuthMockModule };
    };
    SupplierAuthConfigModule.none = function () {
        return { ngModule: NoopModule };
    };
    return SupplierAuthConfigModule;
}());
export { SupplierAuthConfigModule };
